<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <card
              :title="stats.money.title"
              :value="state.novos_pedidos"
              :iconClass="stats.money.iconClass"
              :iconBackground="stats.money.iconBackground"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              :title="stats.users.title"
              :value="state.profissionais"
              :iconClass="stats.users.iconClass"
              :iconBackground="stats.users.iconBackground"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              :title="stats.clients.title"
              :value="state.clinicas"
              :iconClass="stats.clients.iconClass"
              :iconBackground="stats.clients.iconBackground"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              :title="stats.sales.title"
              :value="state.lojas"
              :iconClass="stats.sales.iconClass"
              :iconBackground="stats.sales.iconBackground"
              directionReverse
            ></card>
          </div>
        </div>
        <div class="card">
          <div class="row mt-4">
            <div class="col-md-12 mb-lg-0 mb-4">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 style="color: #212329" class="mb-2">Novos Depoimentos</h6>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead class="thead">
                    <tr>
                      <th scope="col">Nome</th>
                      <th scope="col">Nota</th>
                      <th scope="col">Clínica</th>
                      <th scope="col">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="depoimento in state.depoPendentes"
                      :key="depoimento.id"
                      :value="depoimento.id"
                    >
                      <td>{{ depoimento.nome }}</td>
                      <td>{{ depoimento.nota }}</td>
                      <td>{{ depoimento.clinica.nome }}</td>
                      <td>
                        <button
                          title="Visualizar"
                          class="btn"
                          type="button"
                          @click="abrirModal(depoimento.id)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-eye"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                            />
                            <path
                              d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                            />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-8 mb-lg-0 mb-4">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 style="color: #212329" class="mb-2">
                    Pedidos de Cartões Pendentes
                  </h6>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead class="thead">
                    <tr>
                      <th scope="col">Nome</th>
                      <th scope="col">Tipo</th>
                      <th scope="col">Telefone</th>
                      <th scope="col">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="pedido in state.pedidos"
                      :key="pedido.id"
                      :value="pedido.id"
                    >
                      <td>{{ pedido.nome }}</td>
                      <td>{{ pedido.tipo }}</td>
                      <td>{{ pedido.telefone }}</td>
                      <td>
                        <router-link
                          :to="{
                            name: 'VisualizarPedido',
                            params: { id: pedido.id },
                          }"
                        >
                          <button title="Visualizar" type="button" class="btn">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-eye"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                              />
                              <path
                                d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                              />
                            </svg>
                          </button>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-4">
              <div>
                <img
                  id="img-dash"
                  src="./../../../public/img/littleBoyHandColor.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal :open="state.modalOpen" @close="state.modalOpen = !state.modalOpen">
      <container>
        <div class="container">
          <div class="row">
            <div class="col-md-10">
              <h2 class="h2-name">{{ state.depoimento.nome }}</h2>
            </div>
            <div class="col-md-2">
              <button
                @click="fecharModal()"
                type="button"
                class="btn_cancel"
                title="Cancelat"
              >
                Cancelar
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-10 offset-sm-1">
              <p class="text-depo">{{ state.depoimento.depoimento }}</p>
              <p class="text-nota mb-4">Nota: {{ state.depoimento.nota }}</p>
              <div class="btns_right">
                <button
                  type="button"
                  class="btn_aprovar"
                  @click="aprovarDepoimento(state.depoimento.id)"
                >
                  Aprovar
                </button>
                <button
                  type="button"
                  class="btn_excluir"
                  @click="deleteDepoimento(state.depoimento.id)"
                >
                  Excluir
                </button>
              </div>
            </div>
          </div>
        </div>
      </container>
    </Modal>
  </div>
</template>
<script>
import Modal from "./../Modal/Modal.vue";
import Card from "@/examples/Cards/Card.vue";
import US from "@/assets/img/icons/flags/US.png";
import DE from "@/assets/img/icons/flags/DE.png";
import GB from "@/assets/img/icons/flags/GB.png";
import BR from "@/assets/img/icons/flags/BR.png";
import { onMounted, reactive } from "vue";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  name: "dashboard-default",
  data() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      clinicas: "",
      lojas: "",
      novos_pedidos: "",
      profissionais: "",
      pedidos: [],
      depoPendentes: [],
      depoimento: {},
    });
    onMounted(() => {
      fetchInfos();
      fetchInfoPedidos();
      getDepoimentoPendentes();
    });
    async function fetchInfos() {
      try {
        const { data } = await services.usuario.info({ token });
        state.clinicas = data.clinicas;
        state.lojas = data.lojas;
        state.profissionais = data.profissionais;
        state.novos_pedidos = data.novos_pedidos;
      } catch (error) {
        console.log(error);
      }
    }
    async function getDepoimentoPendentes() {
      try {
        const { data } = await services.clinica.getDepoimentoPendentes({
          token,
        });
        console.log(data);
        state.depoPendentes = data;
        console.log(state.depoPendentes);
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchInfoPedidos() {
      try {
        const { data } = await services.usuario.infoPedidos({ token });
        state.pedidos = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function abrirModal(id_depoimento) {
      state.modalOpen = true;
      try {
        const { data } = await services.clinica.getDepoimentoById({
          id_depoimento,
          token,
        });
        console.log(data);
        state.depoimento = data;
      } catch (error) {
        console.log(error);
      }
    }
    function fecharModal() {
      state.modalOpen = false;
    }
    async function deleteDepoimento(id) {
      try {
        const { data } = await services.clinica.deleteDepoimento({
          id,
          token,
        });
        getDepoimentoPendentes();
        state.modalOpen = false;
        console.log(data);
      } catch (error) {
        console.log(error);
      }
    }
    async function aprovarDepoimento(id) {
      try {
        const { data } = await services.clinica.aprovarDepoimento({
          id,
          token,
        });
        getDepoimentoPendentes();
        state.modalOpen = false;
        console.log(data);
      } catch (error) {
        console.log(error);
      }
    }
    return {
      fecharModal,
      abrirModal,
      deleteDepoimento,
      aprovarDepoimento,
      state,
      stats: {
        money: {
          title: "Novos Pedidos",
          iconClass: "ni ni-credit-card",
          iconBackground: "bg-gradient-dark",
        },
        users: {
          title: "profissionais ativos",
          iconClass: "ni ni-single-02",
          iconBackground: "bg-gradient-dark",
        },
        clients: {
          title: "clinicas ativas",
          iconClass: "ni ni-ambulance",
          iconBackground: "bg-gradient-dark",
        },
        sales: {
          title: "lojas",
          value: "$103,430",
          percentage: "+5%",
          iconClass: "ni ni-cart",
          iconBackground: "bg-gradient-dark",
          detail: "than last month",
        },
      },
      sales: {
        us: {
          country: "United States",
          sales: 2500,
          value: "$230,900",
          bounce: "29.9%",
          flag: US,
        },
        germany: {
          country: "Germany",
          sales: "3.900",
          value: "$440,000",
          bounce: "40.22%",
          flag: DE,
        },
        britain: {
          country: "Great Britain",
          sales: "1.400",
          value: "$190,700",
          bounce: "23.44%",
          flag: GB,
        },
        brasil: {
          country: "Brasil",
          sales: "562",
          value: "$143,960",
          bounce: "32.14%",
          flag: BR,
        },
      },
    };
  },
  components: {
    Card,
    Modal,
  },
};
</script>
<style scoped>
.btn {
  transform: none !important;
  margin-bottom: 0;
  padding: 10px;
  width: 40px;
  background-color: #212329;
  color: #fff;
}
tr {
  text-align: center;
}
#img-dash {
  width: 100%;
}
.h2-name {
  color: #000;
}
.text-depo {
  text-align: justify;
  color: #141414;
  font-size: 14pt;
  margin-bottom: 0;
}
.text-nota {
  color: #141414;
  text-align: left;
  font-size: 14pt;
  font-weight: 600;
}
.btn_excluir {
  padding: 5px;
  width: 100px;
  background: rgb(255, 48, 0);
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_excluir:hover {
  background: rgb(182, 33, 0);
}
.btn_aprovar {
  padding: 5px;
  width: 100px;
  background: greenyellow;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_aprovar:hover {
  background: rgb(137, 202, 39);
}
.btns_right {
  text-align: right;
  margin: 1rem;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: rgb(207, 135, 2);
}
</style>